import { useNavigate } from 'react-router-dom';

import { Nullable } from 'shared_DEPRECATED/types';

import { openJournalSidebar } from 'features/journal';
import { ParticipantTableNotesButton } from 'features/participants/components/Table/Actions/Notes/Button';
import {
  ParticipantsTableLatestSprint,
  ParticipantsTableUserInfo,
} from 'features/participants/config/types';
import { getParticipantUrl } from 'features/participants/utils';
import { useUserContext } from 'features/user/context';

type ParticipantsTableNotesPropTypes = {
  unreadJournalRecordsNumber: number;
  unreadItemDateTime: Nullable<string>;
  latestSprint: ParticipantsTableLatestSprint;
  userInfo: ParticipantsTableUserInfo;
};

export const ParticipantsTableJournalNotes = ({
  unreadJournalRecordsNumber,
  unreadItemDateTime,
  latestSprint,
  userInfo,
}: ParticipantsTableNotesPropTypes) => {
  const navigate = useNavigate();
  const { user } = useUserContext();
  const userLink = getParticipantUrl(userInfo.email);

  const handleNotesButtonClick = () => {
    if (latestSprint?.sprintId) {
      navigate(userLink);
    }

    openJournalSidebar({
      user,
      participantId: userInfo.userId,
      participantEmail: userInfo.email,
    });
  };

  return (
    <ParticipantTableNotesButton
      onClick={handleNotesButtonClick}
      unreadCount={unreadJournalRecordsNumber}
      unreadItemDateTime={unreadItemDateTime}
    />
  );
};
